import {ChangeDetectorRef, Component, OnChanges, OnInit, QueryList, ViewChildren} from '@angular/core';
import {
  BwGraphUserConfigs,
  BwGraphUserConfigsService,
  BwGraphsVvlansService,
  FormattedGraphData,
  FormattedGraphDataService
} from '../../../generated';
import {forkJoin} from 'rxjs';
import * as _ from 'lodash';
import {BaseClientComponent} from '../../base-client.component';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {SelectItem} from 'primeng/api';
import {UIChart} from 'primeng/chart';
import moment from 'moment-timezone';
import {DatePipe} from '@angular/common';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {GraphHandlerService} from '../graph-handler.service';
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import {TechnicalPopService} from '../../../services/technical-pop.service';

@Component({
  selector: 'app-bw-graph-end-to-end',
  templateUrl: './bw-graph-end-to-end.component.html',
  styleUrls: ['./bw-graph-end-to-end.component.scss']
})

export class BwGraphEndToEndComponent extends BaseClientComponent implements OnInit, OnChanges {
  @ViewChildren('chart') charts !: QueryList<UIChart>;

  vvlans: string[];
  selectedVlan: any[] = [];
  selectedVlanForList: any[] = [];
  unit = 'hour';
  zoomOptions = [];
  noGraphs = false;
  listObservable = {};
  graphExecutionTimeOptions = {};
  defaultGraphExecutionTimeOptions = {};
  graphData = {};
  vlanListSelect: any[] = [];
  savedUserConfigsList: SelectItem[] = [];
  userDefaultGraphsParams = {
    graphOption: {},
    selectedVvlans: [],
    selectedBUs: [],
    selectedPeriod: {},
    zoomIn: false,
    timeZone: 'UTC',
    selectedConfiguration: null,
  };
  selectedTimeZone = 'UTC';
  zoomIn = false;
  selectedPeriod: any = {};
  checkboxesModel = {};
  periods = [];
  maxTime: number;
  minTime: number;
  userBwGraphPrefLocalStorageKey = 'userBwGraphPref';
  loadingPrefs = true;
  savedUserConfigs: Array<BwGraphUserConfigs>;
  selectedConfigurationId: string = null;
  selectedConfigurationName: string = null;
  loadingGraphsStatus = false;
  loadedGraphs = [];
  batchToLoad = 0;
  batchedGraphs: any;
  bwGraphUserDefaultConfig?: BwGraphUserConfigs;
  showChangedConfigMessage = false;
  updateRoutesDisabled = true;
  private isOneEtreeFiltredGraphs = false;
  private selectedVlanId: string;
  businessUnitsList: SelectItem[] = [];
  selectedBusinessUnit: string[] = [];
  refreshingGraphs = false;
  refreshingGraphIds = {};
  graphStats = {};
  private crosshairPlugin = {
    id: 'bwE2eCrosshair',
    afterDraw: (chart: any) => {
      const activeElements = chart.tooltip && chart.tooltip.getActiveElements ? chart.tooltip.getActiveElements() : [];
      if (!activeElements.length) {
        return;
      }
      const x = activeElements[0].element.x;
      const ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, chart.chartArea.top);
      ctx.lineTo(x, chart.chartArea.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(11, 11, 11, 0.28)';
      ctx.stroke();
      ctx.restore();
    }
  };
  chartPlugins = [zoomPlugin, this.crosshairPlugin];

  constructor(public authenticationService: AuthenticationService,
              protected utilsService: UtilsService,
              protected http: HttpClient,
              protected datePipe: DatePipe,
              protected technicalPopService: TechnicalPopService,
              private formattedGraphDataService: FormattedGraphDataService,
              private bwGraphUserConfigsService: BwGraphUserConfigsService,
              private bwGraphsVvlansService: BwGraphsVvlansService,
              protected graphHandlerService: GraphHandlerService,
              public route: ActivatedRoute,
              private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
    this.zoomOptions = this.graphHandlerService.zoomOptions;
    this.periods = this.graphHandlerService.periods;
  }

  ngOnChanges() {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const vvlanId = paramMap['params']['vvlanId'];
      if (vvlanId !== null && typeof vvlanId !== 'undefined') {
        this.isOneEtreeFiltredGraphs = true;
        this.selectedVlanId = vvlanId;
      } else {
        this.isOneEtreeFiltredGraphs = false;
      }
    });
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      moment.tz.setDefault('UTC');
      const timeWindow = this.graphHandlerService.initMinAndMaxTime();
      this.minTime = timeWindow.minTime;
      this.maxTime = timeWindow.maxTime;
      this.initializeGraphExecutionTimeOption();
      this.initializeBwGraph();
    });
    this.utilsService.unlockUi();
    this.subscriptions.push(response$);
  }

  public loadNextGraphsBatch() {
    if (this.batchedGraphs && this.batchToLoad < this.batchedGraphs.length) {
      const currentBatch = this.batchedGraphs[this.batchToLoad];
      const graphsToLoad = currentBatch.slice(0, 4);
      graphsToLoad.forEach((index: string) => {
        this.loadGraphForVlan(index);
      });
      this.batchToLoad++;
    }
  }

  public initSavedConfigs() {
    this.savedUserConfigsList = [];
    this.savedUserConfigs = this.authenticationService.userCurrent.bwGraphUserConfigs.filter(userConfig => userConfig.type === 'end-to-end-graph');
    _.forEach(this.savedUserConfigs, (savedUserConfig: BwGraphUserConfigs) => {
      if (savedUserConfig.type === 'end-to-end-graph') {
        this.savedUserConfigsList.push({
          label: savedUserConfig.configName, value: savedUserConfig.id,
        });
      }
    });
    this.savedUserConfigsList.sort((a, b) => a.label.localeCompare(b.label));
    if (this.authenticationService.userCurrent.bwGraphUserDefaultConfig && this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === 'end-to-end-graph').length > 0) {
      const defaultConfig = this.authenticationService.userCurrent.bwGraphUserDefaultConfig.filter(userDefaultConfig => userDefaultConfig.type === 'end-to-end-graph');
      this.bwGraphUserDefaultConfig = _.find(this.authenticationService.userCurrent.bwGraphUserConfigs, {'id': defaultConfig[0]['id']});
      this.selectedConfigurationId = (this.bwGraphUserDefaultConfig) ? this.bwGraphUserDefaultConfig.id : null;
    }
  }

  loadDefaultUserPrefForBwGraph() {
    this.loadingPrefs = true;
    const savedParams = this.utilsService.getUserData(this.userBwGraphPrefLocalStorageKey);
    if (!savedParams) {
      _.forEach(this.vvlans, (vvlan) => {
        this.graphExecutionTimeOptions[vvlan] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
        this.selectedVlan.push(vvlan);
        this.checkboxesModel[vvlan] = true;
      });
      this.selectedVlanForList = this.isOneEtreeFiltredGraphs ? this.filterGraphs(this.selectedVlanId) : this.createSelectedVVlanList();
      this.selectedVlan = this.selectedVlanForList.map(graph => graph.value);
      this.selectedBusinessUnit = this.isOneEtreeFiltredGraphs ? this.getBUUuidsByVlans(this.selectedVlanForList) : this.createSelectedBU();
      if (this.isOneEtreeFiltredGraphs) {
        this.checkboxesModel = {};
        _.forEach(this.selectedVlanForList, (vvlan) => {
          this.checkboxesModel[vvlan.value] = true;
        });
      }
      if (this.isOneEtreeFiltredGraphs) {
        for (const item of this.selectedVlanForList) {
          this.loadGraphForVlan(item.value);
        }
      }
      this.initializeUserDefaultGraphsParams(this.isOneEtreeFiltredGraphs ? this.selectedVlan : this.selectedVlan);
      return;
    }
  }


  isDisplayedData(index: string) {
    if (!this.selectedVlan) {
      return true;
    }
    return this.selectedVlan.some(selected => String(selected) === String(index));
  }

  hideGraph(index) {
    this.checkboxesModel[index] = false;
    this.reinitializeSelectedVlan();
  }

  reloadCharts(index) {
    this.charts.map((chart: UIChart) => {
      if (chart.data.id === index) {
        this.userDefaultGraphsParams.graphOption[index] = chart.options;
        this.utilsService.saveUserData(this.userBwGraphPrefLocalStorageKey, this.userDefaultGraphsParams);
        chart.reinit();
      }
    });
  }

  updateTimeScale(index) {
    this.graphHandlerService.applyTimeScaleUpdate(index, this.charts, this.selectedPeriod, this.minTime, this.userDefaultGraphsParams, () => this.saveUserDataInfo());
  }

  saveUserPrefs(loadSelectedVlan = false) {
    if (!this.vvlans || !this.graphExecutionTimeOptions) {
      return;
    }
    this.showChangedConfigMessage = true;
    if (this.charts) {
      this.charts.map((chart: UIChart) => {
        this.userDefaultGraphsParams.graphOption[chart.data.id] = chart.options;
      });
    }

    if (this.isOneEtreeFiltredGraphs) {
      this.selectedVlanForList = this.vlanListSelect.filter(vlanSelectItem => this.selectedVlan.indexOf(vlanSelectItem.value) > -1);
      const selectedBUUuids = this.vlanListSelect
        .filter(vlan => this.selectedVlan.includes(vlan.value))
        .map(vlan => vlan.billingAccountUUID);
      this.selectedBusinessUnit = selectedBUUuids;
    }
    this.userDefaultGraphsParams.selectedVvlans = this.selectedVlan;
    this.userDefaultGraphsParams.selectedBUs = this.selectedBusinessUnit;
    if (loadSelectedVlan === true) {
      this.loadFirstBatch();
    }
    this.userDefaultGraphsParams.selectedPeriod = this.selectedPeriod;
    this.userDefaultGraphsParams.zoomIn = this.zoomIn;
    this.userDefaultGraphsParams.selectedConfiguration = this.selectedConfigurationId;
    this.userDefaultGraphsParams.timeZone = this.selectedTimeZone;
    this.saveUserDataInfo();
    this.reinitializeCheckBoxModel(this.vvlans, this.selectedVlan);
    this.updateRoutesDisabled = true;
  }

  reinitializeCheckBoxModel(data: string[], selectedData: any[]) {
    this.graphHandlerService.reinitializeCheckBoxModel(data, selectedData, this.checkboxesModel);
  }

  reinitializeSelectedVlan() {
    this.selectedVlan = [];
    _.forEach(this.checkboxesModel, (isSelected, index: string) => {
      if (isSelected === true) {
        this.selectedVlan.push(index);
      }
    });
    this.selectedVlanForList = this.isOneEtreeFiltredGraphs ? this.filterGraphs(this.selectedVlanId) : this.createSelectedVVlanList();
    this.saveUserPrefs();
  }
  getGraphLegend(index: string) {
    return this.graphHandlerService.getGraphLegend(index, this.vlanListSelect);
  }

  getTechnicalPopFromLabel(index: string) {
    return this.graphHandlerService.extractTechnicalPop(this.getGraphLegend(index), /\/(.{3})/);
  }

  resetCharZoom(vvlan) {
    this.graphHandlerService.applyResetZoom(vvlan, this.charts, this.selectedPeriod, this.minTime, this.maxTime);
    this.saveUserPrefs();
  }

  loadSavedConfiguration(configurationToLoad: BwGraphUserConfigs | null = null) {
    const userSavedConfiguration = (!configurationToLoad)
      ? _.find(this.savedUserConfigs, { id: this.selectedConfigurationId }) as BwGraphUserConfigs
      : configurationToLoad;

    if (!configurationToLoad) {
      this.updateDefaultConfiguration([this.bwGraphUserDefaultConfig], userSavedConfiguration);
    }
    if (!userSavedConfiguration) {
      return;
    }
    this.userDefaultGraphsParams = _.cloneDeep(userSavedConfiguration.config);
    this.selectedConfigurationName = _.clone(userSavedConfiguration.configName);
    if (!this.userDefaultGraphsParams.graphOption) {
      _.forEach(this.vvlans, (vvlan) => {
        this.graphExecutionTimeOptions[vvlan] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
      });
    } else {
      this.graphExecutionTimeOptions = this.applyThemeToSavedOptions(this.userDefaultGraphsParams.graphOption);
      _.forEach(this.vvlans, (vvlan) => {
        if (!this.graphExecutionTimeOptions[vvlan]) {
          this.graphExecutionTimeOptions[vvlan] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
        }
      });
    }
    if (this.userDefaultGraphsParams.timeZone) {
      this.selectedTimeZone = this.userDefaultGraphsParams.timeZone;
      moment.tz.setDefault(this.selectedTimeZone);
    }
    // --- store the  saved BUs & saved VLANs ---
    const savedBUs: string[] = Array.isArray(this.userDefaultGraphsParams.selectedBUs)
      ? [...this.userDefaultGraphsParams.selectedBUs]
      : [];
    const savedVvlans: string[] = Array.isArray(this.userDefaultGraphsParams.selectedVvlans)
      ? [...this.userDefaultGraphsParams.selectedVvlans]
      : [];
    if (savedVvlans && savedVvlans.length > 0) {
      this.selectedVlan = [...savedVvlans];
      this.selectedVlanForList = this.createSelectedVVlanList();
      if (!savedBUs || savedBUs.length === 0) {
        this.selectedBusinessUnit = this.getBUUuidsByVlans(this.selectedVlanForList);
      } else {
        this.selectedBusinessUnit = [...savedBUs];
      }
      this.reinitializeCheckBoxModel(this.vvlans, this.selectedVlan);
    } else if (savedBUs && savedBUs.length > 0) {
      this.selectedBusinessUnit = [...savedBUs];
      this.filterbyBusinessUnit();
      this.reinitializeCheckBoxModel(this.vvlans, this.selectedVlan);
    } else {
      this.selectedVlan = [];
      this.selectedVlanForList = [];
      this.selectedBusinessUnit = this.businessUnitsList.map(b => b.value);
    }
    if (this.userDefaultGraphsParams.selectedPeriod) {
      this.selectedPeriod = this.userDefaultGraphsParams.selectedPeriod;
    }
    this.zoomIn = this.userDefaultGraphsParams.zoomIn;
    this.userDefaultGraphsParams.selectedConfiguration = this.selectedConfigurationId;
    this.loadFirstBatch();
    if (this.charts) {
      this.charts.map((chart: UIChart) => {
        if (this.graphExecutionTimeOptions[chart.data.id]) {
          chart.options = this.graphExecutionTimeOptions[chart.data.id];
          chart.reinit();
        }
      });
    }
    this.loadingPrefs = false;
    // this.saveUserPrefs();
    this.showChangedConfigMessage = false;
  }

  private applyThemeToSavedOptions(savedOptionsByGraph: any): any {
    return this.graphHandlerService.applyThemeToSavedOptions(savedOptionsByGraph, this.defaultGraphExecutionTimeOptions);
  }

  public loadFirstBatch() {
    this.batchToLoad = 0;
    const selectedData = this.isOneEtreeFiltredGraphs ? this.filterGraphs(this.selectedVlanId).map(({value}) => value) : this.selectedVlan;
    this.batchedGraphs = _.chunk(selectedData, this.graphHandlerService.INFINIT_SCROLL_BATCH_SIZE);
    _.forEach(this.batchedGraphs[0], (index: string) => {
      this.loadGraphForVlan(index);
    });
    this.batchToLoad++;
  }

  public saveConfiguration() {
    this.saveUserPrefs();
    const configuration = _.find(this.savedUserConfigsList, {'label': this.selectedConfigurationName});
    if (configuration) {
      this.updateConfiguration(configuration.value);
    } else {
      this.createNewConfiguration();
    }
  }

  createNewConfiguration() {
    const configuration = this.utilsService.loadUserPref(this.userBwGraphPrefLocalStorageKey);
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName,
      config: configuration,
      user: '/api/users/' + this.authenticationService.userCurrent.id,
      createdBy: this.authenticationService.userCurrent.email,
      type: 'end-to-end-graph',
      isDefault: true,
    };
    this.bwGraphUserConfigsService.postBwGraphUserConfigsCollection(graphConfiguration).subscribe({
      next: (config) => {
        this.authenticationService.userCurrent.bwGraphUserConfigs.push(config);
        this.updateDefaultConfiguration(this.authenticationService.userCurrent.bwGraphUserConfigs, config);
        this.initSavedConfigs();
      }, error: (error) => {
        this.utilsService.handleErrorWebservice$(error);
      }
    });
  }

  updateConfiguration(configurationId: string) {
    const configuration = this.loadUserGraphPref();
    const graphConfiguration = <BwGraphUserConfigs>{
      configName: this.selectedConfigurationName, config: configuration, type: 'end-to-end-graph', isDefault: true,
    };
    this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(configurationId, graphConfiguration)
      .subscribe({
        next: (config) => {
          const index = this.authenticationService.userCurrent.bwGraphUserConfigs
            .findIndex(c => c.id === configurationId);

          if (index !== -1) {
            this.authenticationService.userCurrent.bwGraphUserConfigs[index] = config;
          }
          this.initSavedConfigs();
          this.showChangedConfigMessage = false;
        }, error: (error) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  resetFilters() {
    this.isOneEtreeFiltredGraphs = false;
    this.selectedVlan = [];
    this.selectedBusinessUnit = [];
    this.zoomIn = false;
    this.selectedTimeZone = 'UTC';
    this.selectedConfigurationId = null;
    this.selectedConfigurationName = null;
    this.createSelectedDataGraphs();
    this.charts.map((chart: UIChart) => {
      chart.options.scales.x.max = null;
      chart.options.scales.x.time.unit = this.unit;
      chart.options.scales.x.min = this.minTime;
      chart.reinit();
    });
    this.updateDefaultConfiguration([this.bwGraphUserDefaultConfig], null);
    this.saveUserPrefs();
    this.showChangedConfigMessage = false;
    this.loadFirstBatch();
  }

  changeTimeZone() {
    this.selectedTimeZone = this.graphHandlerService.applyTimeZoneChange(this.selectedTimeZone, this.charts);
    this.saveUserPrefs();
  }

  onSelect() {
    this.updateRoutesDisabled = this.selectedVlan.length === 0;
  }

  private initializeGraphExecutionTimeOption() {
    this.defaultGraphExecutionTimeOptions = this.graphHandlerService.getThemedGraphExecutionTimeOptions(this.onZoomComplete.bind(this));
    this.defaultGraphExecutionTimeOptions['scales'] = this.graphHandlerService.setThemedPlrLatencyScales(this.minTime, this.unit, this.maxTime);
  }

  private onZoomComplete(chart: any): void {
    this.graphHandlerService.applyZoomComplete(this.graphExecutionTimeOptions, chart, () => this.saveUserPrefs());
  }

  private initializeBwGraph() {
    forkJoin([
      this.bwGraphsVvlansService.getBwGraphsVvlans(),
      this.graphHandlerService.loadUserConfigs()
    ]).subscribe({
      next: ([response]) => {
        this.loadingPrefs = false;
        this.vvlans = response.vvlans;
        this.vlanListSelect = response.vvlansList.sort((a, b) => a.label.localeCompare(b.label));
        if (!this.vvlans || this.vvlans.length <= 0) {
          this.noGraphs = true;
        } else {
          _.forEach(this.vvlans, (vlan) => {
            this.selectedPeriod[vlan] = 360;
            this.checkboxesModel[vlan] = false;
          });
          if (this.authenticationService.userCurrent.permissions.isMckayUser) {
            const accountEntries: any[] = [];
            this.vlanListSelect.forEach(item => {
              if (item.billingAccounts && Array.isArray(item.billingAccounts)) {
                item.billingAccounts.forEach(acc => {
                  accountEntries.push({
                    label: acc.name, value: acc.uuid, title: item.value
                  });
                });
              } else if (item.billingAccountUUID) {
                accountEntries.push({
                  label: item.billingAccountName, value: item.billingAccountUUID, title: item.value
                });
              }
            });
            this.businessUnitsList = Array.from(new Map(accountEntries.map(acc => [acc.value, acc])).values());
          } else {
            this.businessUnitsList = Array.from(
              new Map(
                this.vlanListSelect.map(item => [item.billingAccountUUID, {
                  label: item.billingAccountName,
                  value: item.billingAccountUUID,
                  title: item.value
                }])
              ).values()
            );
          }
          this.businessUnitsList.sort((a, b) => a.label.localeCompare(b.label));
          this.selectedBusinessUnit = this.businessUnitsList.map(bu => bu.value);
          this.initSavedConfigs();
          if (this.selectedConfigurationId) {
            this.loadSavedConfiguration(this.bwGraphUserDefaultConfig);
          } else {
            this.utilsService.removeUserData(this.userBwGraphPrefLocalStorageKey);
            this.loadDefaultUserPrefForBwGraph();
          }
          this.loadFirstBatch();
        }
        this.utilsService.unlockUi();
      },
      error: () => {
        this.noGraphs = true;
        this.utilsService.unlockUi();
      }
    });
  }

  private initializeUserDefaultGraphsParams(selectedIndex) {
    this.userDefaultGraphsParams.selectedVvlans = selectedIndex;
    this.userDefaultGraphsParams.timeZone = this.selectedTimeZone;
    this.userDefaultGraphsParams.selectedConfiguration = this.selectedConfigurationId;
    this.saveUserDataInfo();
    this.loadingPrefs = false;
    this.showChangedConfigMessage = false;
  }

  private loadGraphForVlan(vvlan: string, forceRefresh = false, onComplete?: () => void) {
    this.loadingGraphsStatus = true;
    if (!vvlan) {
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!this.isDisplayedData(vvlan)) {
      this.loadingGraphsStatus = false;
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (this.graphData[vvlan] && !forceRefresh) {
      this.loadingGraphsStatus = false;
      this.loadedGraphs.push(vvlan);
      if (onComplete) {
        onComplete();
      }
      return;
    }
    if (!forceRefresh) {
      this.loadedGraphs.push(vvlan);
    }
    this.utilsService.lockUi();
    this.listObservable[vvlan] = this.formattedGraphDataService.getFormattedGraphDataItem(vvlan).subscribe({
      next: (response: FormattedGraphData) => {
        const adIndex = this.getAdIndex(vvlan, this.vlanListSelect);
        if (adIndex) {
          this.retrieveActiveDiversityGraphData(vvlan, response, forceRefresh, onComplete);
        } else {
          this.applyGraphData(vvlan, response.id, response.labels, response.datasets, forceRefresh);
        }
        this.updateTimeScale(vvlan);
        this.changeDetectorRef.detectChanges();
        this.loadingGraphsStatus = false;
        this.utilsService.unlockUi();
        if (!adIndex && onComplete) {
          onComplete();
        }
      }, error: () => {
        this.graphData[vvlan] = {
          id: vvlan, labels: 'No data available', datasets: []
        };
        this.loadingGraphsStatus = false;
        this.utilsService.unlockUi();
        if (onComplete) {
          onComplete();
        }
      }
    });
  }

  private retrieveActiveDiversityGraphData(vvlan: string, response: FormattedGraphData, forceRefresh = false, onComplete?: () => void) {
    this.formattedGraphDataService.getFormattedGraphDataItem(this.getAdIndex(vvlan, this.vlanListSelect)).subscribe({
      next: (res) => {
        const datasets = res.datasets;
        datasets[1].label = 'PLR (AD)';
        datasets[2] = response.datasets[1];
        datasets[2].label = 'PLR (Main)';
        datasets[1].borderColor = '#92C3FE';
        datasets[1].backgroundColor = '#92C3FE';
        this.applyGraphData(vvlan, response.id, res.labels, datasets, forceRefresh);
        if (onComplete) {
          onComplete();
        }
      }, error: () => {
        this.applyGraphData(vvlan, response.id, response.labels, response.datasets, forceRefresh);
        if (onComplete) {
          onComplete();
        }
      }
    });
  }

  private applyGraphData(vvlan: string, id: any, labels: any, datasets: any[], forceRefresh: boolean) {
    const existingGraphData = this.graphData[vvlan];
    if (forceRefresh && existingGraphData && existingGraphData.datasets && existingGraphData.datasets.length === datasets.length) {
      existingGraphData.labels = labels;
      datasets.forEach((dataset, i) => {
        existingGraphData.datasets[i].data = dataset.data;
      });
      this.graphStats[vvlan] = this.computeGraphStats(existingGraphData.datasets);
      this.charts.forEach((chart: UIChart) => {
        if (chart.data.id === vvlan) {
          this.reanchorRelativeTimeWindow(vvlan);
          chart.reinit();
        }
      });
    } else {
      this.graphData[vvlan] = {id, labels, datasets};
      this.graphStats[vvlan] = this.computeGraphStats(datasets);
    }
  }

  private reanchorRelativeTimeWindow(index: string) {
    this.graphHandlerService.reanchorRelativeTimeWindow(index, this.selectedPeriod, this.graphExecutionTimeOptions);
  }

  refreshGraphsData() {
    const routesToRefresh = _.filter(this.vvlans, (vvlan) => this.listObservable[vvlan] && this.isDisplayedData(vvlan));
    if (routesToRefresh.length === 0) {
      return;
    }
    this.refreshingGraphs = true;
    let remaining = routesToRefresh.length;
    const onRouteDone = () => {
      remaining--;
      if (remaining <= 0) {
        this.refreshingGraphs = false;
      }
    };
    _.forEach(routesToRefresh, (vvlan) => this.loadGraphForVlan(vvlan, true, onRouteDone));
  }

  refreshSingleGraph(index) {
    if (this.refreshingGraphIds[index]) {
      return;
    }
    this.refreshingGraphIds[index] = true;
    this.loadGraphForVlan(index, true, () => {
      this.refreshingGraphIds[index] = false;
    });
  }

  private computeGraphStats(datasets: any[]) {
    return datasets.map(dataset => ({
      label: dataset.label,
      color: dataset.borderColor,
      stats: this.computeSeriesStats(dataset.data)
    }));
  }

  private computeSeriesStats(values: any[]) {
    return this.graphHandlerService.computeSeriesStats(values);
  }

  private exportFileName(index: string, extension: string) {
    return this.graphHandlerService.buildExportFileName(this.getGraphLegend(index), '-end-to-end-', extension);
  }

  private downloadFile(href: string, fileName: string) {
    this.graphHandlerService.downloadFile(href, fileName);
  }

  exportCsv(index: string) {
    const data = this.graphData[index];
    if (!data || !data.datasets || data.datasets.length === 0) {
      return;
    }
    const rows = ['Date;' + data.datasets.map(dataset => dataset.label).join(';')];
    _.forEach(data.labels, (timestamp, i) => {
      const date = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      const values = data.datasets.map(dataset => dataset.data[i]).join(';');
      rows.push(date + ';' + values);
    });
    const blob = new Blob([rows.join('\n')], {type: 'text/csv;charset=utf-8'});
    const url = URL.createObjectURL(blob);
    this.downloadFile(url, this.exportFileName(index, 'csv'));
    URL.revokeObjectURL(url);
  }

  exportPng(index: string) {
    this.graphHandlerService.exportChartPng(this.charts, index, this.exportFileName(index, 'png'));
  }

  getAdIndex(index: string, dataList: any) {
    const data = _.find(dataList, {'value': index});
    return data.active_diversity;
  }

  private saveUserDataInfo() {
    this.utilsService.saveUserData(this.userBwGraphPrefLocalStorageKey, this.userDefaultGraphsParams);
  }

  private loadUserGraphPref() {
    return this.utilsService.loadUserPref(this.userBwGraphPrefLocalStorageKey);
  }

  private createSelectedDataGraphs() {
    _.forEach(this.vvlans, (vvlan) => {
      this.selectedVlan.push(vvlan);
      this.selectedPeriod[vvlan] = 360;
      this.graphExecutionTimeOptions[vvlan] = _.cloneDeep(this.defaultGraphExecutionTimeOptions);
    });
    this.selectedVlanForList = this.isOneEtreeFiltredGraphs ? this.filterGraphs(this.selectedVlanId) : this.createSelectedVVlanList();
    this.reinitializeCheckBoxModel(this.vvlans, this.selectedVlan);
  }

  private updateDefaultConfiguration(oldConfigurations: Array<BwGraphUserConfigs>, newConfiguration: BwGraphUserConfigs = null) {
    _.forEach(oldConfigurations, (oldConfiguration: BwGraphUserConfigs) => {
      if (oldConfiguration && oldConfiguration.type === 'end-to-end-graph') {
        this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(oldConfiguration.id, {isDefault: false}).subscribe();
        this.bwGraphUserDefaultConfig = null;
      }
    });

    if (newConfiguration && newConfiguration.type === 'end-to-end-graph') {
      this.bwGraphUserConfigsService.putBwGraphUserConfigsItem(newConfiguration.id, {isDefault: true}).subscribe({
        next: (result: BwGraphUserConfigs) => {
          this.bwGraphUserDefaultConfig = result;
          this.selectedConfigurationId = result.id;
          this.showChangedConfigMessage = false;
        }, error: (error) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
    } else if (!this.isOneEtreeFiltredGraphs) {
      this.authenticationService.userCurrent.bwGraphUserDefaultConfig = null;
    }
  }

  private createSelectedVVlanList() {
    return this.vlanListSelect.filter(vlanSelectItem => this.selectedVlan.indexOf(vlanSelectItem.value) > -1);
  }

  private filterGraphs(vvlanId: string) {
    const filteredVlanList = this.vlanListSelect.filter(item => item.value.includes(vvlanId));
    if (filteredVlanList.length !== 0) {
      return filteredVlanList;
    } else {
      this.noGraphs = true;
    }
  }

  getBUUuidsByVlans(vlanList: any[]): string[] {
    const set = new Set<string>();
    vlanList.forEach(vlan => {
      if (vlan.billingAccounts && Array.isArray(vlan.billingAccounts)) {
        vlan.billingAccounts.forEach((acc: any) => {
          if (acc && acc.uuid) {
            set.add(acc.uuid);
          }
        });
      } else if (vlan.billingAccountUUID) {
        set.add(vlan.billingAccountUUID);
      }
    });
    return Array.from(set);
  }


  filterbyBusinessUnit(): void {
    if (!this.selectedBusinessUnit || this.selectedBusinessUnit.length === 0) {
      this.selectedVlan = [];
      this.selectedVlanForList = [];
      return;
    }
    let filteredVlanList;
    if (this.authenticationService.userCurrent.permissions.isMckayUser) {
      filteredVlanList = this.vlanListSelect.filter(vlan => {
        if (vlan.billingAccounts && Array.isArray(vlan.billingAccounts)) {
          return vlan.billingAccounts.some(acc =>
            this.selectedBusinessUnit.includes(acc.uuid)
          );
        } else {
          return this.selectedBusinessUnit.includes(vlan.billingAccountUUID);
        }
      });
    } else {
      filteredVlanList = this.vlanListSelect.filter(vlan =>
        this.selectedBusinessUnit.includes(vlan.billingAccountUUID)
      );
    }
    this.selectedVlan = filteredVlanList.map(vlan => vlan.value);
    this.selectedVlanForList = filteredVlanList;
    this.saveUserPrefs();
    this.updateRoutesDisabled = this.selectedVlanForList.length === 0;
  }

  private createSelectedBU(): string[] {
    return this.businessUnitsList
      .filter(item => this.selectedVlan.includes(item.title))
      .map(item => item.value);
  }
}
